import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/obras/';

class ObrasService{
	constructor(){
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type':'application/json',
				'authorization':'Bearer ' + (data ? data.token:'')
			};
		});
	}

	findObrasByFiltro(idContribuinte, filtro){
		return axios.get(API_URL+'allObras?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers});
	}

	findTipoObraByFiltro(idCliente, filtro){
		return axios.get(API_URL+'allTipoObra?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
	}

	findTipoDescontoByFiltro(idCliente, filtro){
		return axios.get(API_URL+'allTipoDesconto?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
	}

	getObras(id){
		return axios.get(API_URL+id, {headers: this.headers});
	}

	saveObras(obras){
		return axios.post(API_URL, JSON.stringify(obras), {headers: this.headers});
	}

	removeObras(id){
		return axios.delete(API_URL + id ,{headers: this.headers});
	}

	findAllByContirbuinte(filtro, idContribuinte) {
        return axios.get(API_URL + 'allByContirbuinte?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }
}

export default new ObrasService();